import "firebase/storage"
import { Fragment } from "react"
import { useStorage } from "reactfire"
import { Box, VisuallyHidden } from "@chakra-ui/react"

const UploadButton = ({ setIsLoading, onUploaded, children }) => {
  const storage = useStorage()

  const onChange = (event) => {
    setIsLoading(true)
    const fileList = event.target.files
    const fileToUpload = fileList[0]
    const fileName = fileToUpload.name
    const newRef = storage.ref("images").child(fileName)

    const uploadTask = newRef.put(fileToUpload)

    uploadTask.then((e) => {
      onUploaded(newRef.fullPath)
      setIsLoading(false)
    })
  }

  return (
    <Fragment>
      <VisuallyHidden>
        <input
          type="file"
          accept="image/png, image/jpeg"
          onChange={onChange}
          id="upload-file-button"
        />
      </VisuallyHidden>
      <label htmlFor="upload-file-button">
        <Box cursor="pointer">{children}</Box>
      </label>
    </Fragment>
  )
}

export default UploadButton
